import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL, USERS_API_URL } from '../../../../config';
import brokersAxios from '../../../../utils/axios/brokers-roles.axios';
import { PaginatedChats } from '../../../../interfaces/chat/paginatedStore.type';
import deviceAxios from '../../../../utils/axios/device.axios';

const tryToFetchChats = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedChats>> => {
    const url = filters
        ? `${USERS_API_URL}/ai-search-engine/charles?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${USERS_API_URL}/ai-search-engine/charles?page=${pageNumber}&size=${pageSize}`;
    return brokersAxios.put<PaginatedChats>(url, { filters: data });
};

const tryToFetchAllChats = (): Promise<AxiosResponse<any>> => {
    return brokersAxios.get(`${USERS_API_URL}/ai-search-engine/all`);
};

const tryToCreateChatMessage = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.post(`${DEVICE_INFO_API_URL}/ai-search-engine`, data);
};

const tryToUploadChatFiles = (data: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.post(`${USERS_API_URL}/hotel-world-user-invites/upload-chat-files`, data);
};

const tryToFetchModels = (): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/ai-models/all`);
};

const tryToUploadModels = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/ai-search-engine/add-search-engines`, data);
};

const tryToAddPrompts = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.post(`${DEVICE_INFO_API_URL}/ai-search-engine/add-prompts`, data);
};

const tryToAddCompetitors = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/ai-search-engine/add-search-competitors`, data);
};

export const ChatsService = {
    tryToFetchChats,
    tryToFetchModels,
    tryToFetchAllChats,
    tryToCreateChatMessage,
    tryToUploadChatFiles,
    tryToUploadModels,
    tryToAddPrompts,
    tryToAddCompetitors
};